/* src/app/shared/components/camera-decorator/camera-decorator.component.less */
:host {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.frame {
  position: relative;
  margin: auto;
}
.frame .corner {
  position: absolute;
  height: 3.125rem;
  width: 3.125rem;
}
.frame .corner.top-left {
  border-left: solid 0.125em #005eb8;
  border-top: solid 0.125em #005eb8;
}
.frame .corner.bot-left {
  border-left: solid 0.125em #005eb8;
  border-bottom: solid 0.125em #005eb8;
}
.frame .corner.top-right {
  border-right: solid 0.125em #005eb8;
  border-top: solid 0.125em #005eb8;
}
.frame .corner.bot-right {
  border-right: solid 0.125em #005eb8;
  border-bottom: solid 0.125em #005eb8;
}
.frame .corner.flash {
  border-color: #ffffff;
}
.frame .error-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 0);
  font-weight: 700;
}
/*# sourceMappingURL=camera-decorator.component.css.map */
